<template>
  <content-editor
    permission="blog"
    :fields="fields"
    @update="updateState"
    :publication="true"
    :updatePossible="true"
    endpoint="blog"
    previewModule="blog"
    module="blog"
    />
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';

export default {
  mixins: [ContentDetail],
  data() {
    return {
      module: 'blog',
      fields: [
        {
          name: 'notes',
          required: false,
        },
        {
          name: 'branches',
          required: true,
        },
        {
          name: 'lightbox',
          required: false,
        },
        {
          name: 'read-confirmation',
          required: false,
        },
        {
          name: 'title',
          required: true,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'status',
          required: true,
        },
        {
          name: 'recap',
          required: false,
        },
        {
          name: 'categories',
          required: true,
        },
        {
          name: 'tags',
          required: false,
        },
        {
          name: 'targets',
          required: true,
        },
        {
          name: 'resource_author',
          required: false,
        },
        {
          name: 'image',
          required: true,
        },
        {
          name: 'seo_keywords',
          required: false,
        },
      ],
    };
  },
  components: {
    ContentEditor,
  },
};
</script>
